export const Platform = {
  IOS: 'ios',
  ANDROID: 'android',
  WEB: 'web',
} as const;
